import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Guoman from "../pages/guoman/page";
import Riman from "../pages/riman/page";
import Top from "../pages/top/page";
import ComicDetail from "../pages/comic/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guoman",
    element: <Guoman />,
  },
  {
    path: "/riman",
    element: <Riman />,
  },
  {
    path: "/top",
    element: <Top />,
  },
  {
    path: "/comic/:id",
    element: <ComicDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;